export function extractUserConsent() {
  if (typeof window === 'undefined' || !window.Cookies || !window.Cookies.get('OptanonConsent')) {
    return {};
  }
  const oneTrustUserConsent = parseQueryString(window.Cookies.get('OptanonConsent'));
  return oneTrustUserConsent;
}

export function identifyUserTimezone(user) {
  const sessionKey = 'timezoneSent';
  const { user_id, identity_id, email } = user;

  if (!sessionStorage.getItem(sessionKey)) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const traits = { timezone, identity_id, email, call_location: 'new_session' };
    analytics.identify(user_id, traits);
    sessionStorage.setItem(sessionKey, true);
  }
}

export function analyticsIdentify(userId, traits = {}) {
  return analytics.identify(userId, traits, {
    context: buildAnalyticsConsentPayload(),
  });
}

export function analyticsTrack(eventName, properties = {}) {
  let options = {};
  if (currentUser?.identity_id) {
    options = { context: { identity_id: currentUser.identity_id } };
  }

  options = { ...options.context, ...buildAnalyticsConsentPayload() };

  return analytics.track(eventName, properties, options);
}

export function parseQueryString(queryString) {
  const pairs = queryString.split('&');
  const result = {};

  pairs.forEach((pair) => {
    const [key, value] = pair.split('=');
    result[decodeURIComponent(key)] = decodeURIComponent(value);
  });

  return result;
}

export function buildAnalyticsConsentPayload() {
  const userConsent = extractUserConsent();
  return {
    consent: {
      onetrust: userConsent?.groups,
      onetrust_user_id: userConsent?.consentId,
    },
  };
}

export function configureAhoy() {
  if (!window.ahoy) return;
  // The useBeacon option in Ahoy.js is a configuration setting that determines how events are sent from the client to the server.
  // If useBeacon is set to true, Ahoy.js will use the Beacon API to send tracking data.
  // link for Beacon API: https://developer.mozilla.org/en-US/docs/Web/API/Beacon_API
  // If useBeacon is set to false, Ahoy.js will use a standard AJAX request to send tracking data.
  // https://github.com/ankane/ahoy.js
  ahoy.configure({ useBeacon: false });

  ahoy.visitParams = () => {
    const params = {};
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.forEach((value, key) => {
      params[key] = value;
    });
    return params;
  };

  // Patch ahoy.track to truncate large string props
  // TrackAll will serialize click events into properties that can include
  // large sections of the document. These can end up in the session
  // cookies which can result in 400 responses as they cookies associated
  // with a request are too large
  const originalTrack = ahoy.track;

  ahoy.track = function (name, properties) {
    const MAX_LEN = 300;
    const safeProps = {};

    for (const key in properties) {
      let value = properties[key];

      if (typeof value === 'string') {
        value = value.trim();
        if (value.length > MAX_LEN) {
          console.warn('[Ahoy] Truncated large property:', key, value.length);
          value = value.substring(0, MAX_LEN);
        }
      }

      safeProps[key] = value;
    }

    return originalTrack.call(this, name, safeProps);
  };

  const originalSet = ahoy.setCookie;
  const originalGet = ahoy.getCookie;

  const MAX_COOKIE_SIZE = 3800;

  function compress(json) {
    return LZString.compressToEncodedURIComponent(json);
  }

  function decompress(data) {
    return LZString.decompressFromEncodedURIComponent(data);
  }

  ahoy.setCookie = function (key, value, minutes) {
    if (key === 'ahoy_events') {
      try {
        const compressed = compress(value);
        if (compressed.length < MAX_COOKIE_SIZE) {
          return originalSet.call(this, key, compressed, minutes);
        } else {
          console.warn('Ahoy event payload too large for cookie even after compression');
        }
      } catch (e) {
        console.error('Failed to compress ahoy_events', e);
      }
      return; // drop the event if the size is too large
    }

    return originalSet.call(this, key, value, minutes);
  };

  ahoy.getCookie = function (key) {
    const val = originalGet.call(this, key);
    if (key === 'ahoy_events' && val) {
      try {
        return decompress(val);
      } catch (e) {
        console.error('Failed to decompress ahoy_events', e);
        return null;
      }
    }
    return val;
  };
}

export function setupCustomClickTracking() {
  $(document).on('click', '.track-click', function () {
    const $this = $(this);
    const ahoyEventName = `Clicked ${$this.data('ahoy-name') || $this.data('name')}`;

    const properties = {
      awareness_bar_text: $this.data('awareness-bar-text'),
      can_read_content: window.isCurrentUserSubscriber, // set in layout
      identifier: $this.data('identifier'),
      location: $this.data('location'),
      name: $this.data('name'),
      page: window.location.pathname,
      type: $this.data('type'),
    };

    if (window.trackEvent) {
      window.trackEvent('Clicks', ahoyEventName, properties);
    }
  });
}

export function setupAnalytics() {
  configureAhoy();
  setupCustomClickTracking();
  ahoy.start();
  ahoy.trackAll();
}
